import { IConfigsType } from '../../types'

const fwWingstopManualDataCorrection: IConfigsType = {
  'fw_wingstop-admin': {
    '/:brand/manual_data_correction': {
      groupFilter: {
        api: 'locationFilter',
        autoComplete: true,
        width: 250,
      },
      dateFilter: {
        types: ['yesterday', 'custom'],
        defaultType: 'yesterday',
        isDailyCustom: true,
      },
      title: {
        type: 'title',
        title: 'Manual NBO Data Correction',
      },
      aiBlackbox: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['fwWingstopManualDataCorrection'],
        isLocationPage: true,
        hasDateFilter: true,
        hasGroupFilter: true,
      },
    },
  },
}

export default fwWingstopManualDataCorrection
